// Phone helpers for auth forms. The backend only accepts international format
// (+996…); people in Kyrgyzstan usually type "0555 12 34 56" or "555123456",
// so we normalise instead of rejecting.

const KG = '996';

/** Digits the user typed for a Kyrgyz number (max 9, without 996 / leading 0). */
export function kgDigits(input: string): string {
  let d = input.replace(/\D/g, '');
  if (d.startsWith(KG)) d = d.slice(3);
  else if (d.startsWith('0')) d = d.slice(1);
  return d.slice(0, 9);
}

/** "555 12 34 56" — shown after the fixed "+996" prefix. */
export function formatKgLocal(digits: string): string {
  const d = digits.slice(0, 9);
  return [d.slice(0, 3), d.slice(3, 5), d.slice(5, 7), d.slice(7, 9)].filter(Boolean).join(' ');
}

export const isValidKgPhone = (digits: string): boolean => /^[2-9]\d{8}$/.test(digits);

/** What the API expects: "+996555123456". */
export const toApiPhone = (digits: string): string => `+${KG}${digits}`;
